var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.SamsungAvplay = youbora.Adapter.extend({
  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    if (webapis && webapis.avplay && webapis.avplay.getCurrentTime) {
      return webapis.avplay.getCurrentTime() / 1000
    }
    return null
  },

  /** Override to return video duration */
  getDuration: function () {
    try {
      if (webapis && webapis.avplay && webapis.avplay.getDuration && webapis.avplay.getDuration()) {
        return webapis.avplay.getDuration() / 1000
      }
      return null
    } catch (e) {
      return null
    }
  },

  /** Override to return current bitrate */
  getBitrate: function () {
    if (webapis && webapis.avplay && webapis.avplay.getCurrentStreamInfo && webapis.avplay.getCurrentStreamInfo() && webapis.avplay.getCurrentStreamInfo()[0]) {
      var j = JSON.parse(webapis.avplay.getCurrentStreamInfo()[0].extra_info)
      var bitrate = (j.Bit_rate && j.Bit_rate != "0") ? j.Bit_rate : -1;
      if (bitrate < 1e4) { bitrate *= 100 }//lower than 10k, for example: 9,999 -> 9,999,000 (it wont be less than 10kbps)
      else if (bitrate > 1e7) { bitrate /= 100 }//higher than 10M, for example: 15,000,000 -> 15,000 (it wont be more than 10Mbps)
      return bitrate
    }
    return null
  },

  /** Override to return rendition */
  getRendition: function () {
    try {
      if (webapis && webapis.avplay && webapis.avplay.getCurrentStreamInfo && webapis.avplay.getCurrentStreamInfo() && webapis.avplay.getCurrentStreamInfo()[0]) {
        var bitrate = this.getBitrate()
        var j = JSON.parse(webapis.avplay.getCurrentStreamInfo()[0].extra_info)
        if (j.Width && j.Height && bitrate) {
          return youbora.Util.buildRenditionString(j.Width, j.Height, bitrate)
        } else if (bitrate) {
          return youbora.Util.buildRenditionString(bitrate)
        }
      }
      return null
    } catch (e) {
      return null
    }
  },

  /** Override to return player version */
  getPlayerVersion: function () {
    if (webapis && webapis.avplay && webapis.avplay.getVersion) {
      return webapis.avplay.getVersion()
    }
    return null
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return 'AVPlay'
  },

  /** Register listeners to this.player. */
  registerListeners: function () {
    // Enable playhead monitor (buffer = true, seek = false)
    this.monitorPlayhead(true, true)
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {
    // Disable playhead monitoring
    this.monitor.stop()
  }
})

module.exports = youbora.adapters.SamsungAvplay
